<template>
    <a href="#" :class="stylesClass" title="Checkout" @click="openSearch">{{text}}</a>
</template>

<script>
    import {bus} from '../../bus'
    export default {
        props: [
            'stylesClass',
            'text'
        ],
        data() {
            return {
            }
        },
        methods: {
            openSearch(e) {
                e.preventDefault()
                bus.$emit('open-search-wrap')
            }
        }
    }
</script>
